export class MultiTwoBar {
  public names = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه'];
}
export const multiTwoBar = [
  {
  name: 'شنبه',
    series: [
  {
    name: 'هفته گذشته',
    value: 3
  },
  {
    name: 'هفته جاری',
    value: 4
  }
]
},

{
  name: 'یکشنبه',
    series: [
  {
    name: 'هفته گذشته',
    value: 2
  },
  {
    name: 'هفته جاری',
    value: 1
  }
]
},

{
  name: 'دوشنبه',
    series: [
  {
    name: 'هفته گذشته',
    value: 3
  },
  {
    name: 'هفته جاری',
    value: 3
  }
]
},
{
  name: 'سه شنبه',
    series: [
  {
    name: 'هفته گذشته',
    value: 3
  },
  {
    name: 'هفته جاری',
    value: 4
  }
]
},
{
  name: 'چهارشنبه',
    series: [
  {
    name: 'هفته گذشته',
    value: 4
  },
  {
    name: 'هفته جاری',
    value: 5
  }
]
},
{
  name: 'پنجشنبه',
    series: [
  {
    name: 'هفته گذشته',
    value: 2
  },
  {
    name: 'هفته جاری',
    value: 4
  }
]
},
{
  name: 'جمعه',
    series: [
  {
    name: 'هفته گذشته',
    value: 4
  },
  {
    name: 'هفته جاری',
    value: 2
  }
]
}
];
export const singleCategory = [
  {
    name: 'سیزده اسفند',
    value: 3
  },
  {
    name: 'چهارده اسفند',
    value: 7
  },
  {
    name: 'پانزده اسفند',
    value: 2
  },
  {
    name: 'شانزده اسفند',
    value: 5
  }
];
export const multiLine = [
  {
    name: 'نمودار کلی',
    series: [
      {
        name: 'فروردین',
        value: 12
      },
      {
        name: 'اردیبهشت',
        value: 18
      },
      {
        name: 'خرداد',
        value: 26
      },
      {
        name: 'تیر',
        value: 5
      },
      {
        name: 'مرداد',
        value: 35
      },
      {
        name: 'شهریور',
        value: 40
      },
      {
        name: 'مهر',
        value: 18
      },
      {
        name: 'آبان',
        value: 20
      },
      {
        name: 'آذر',
        value: 32
      },
      {
        name: 'دی',
        value: 30
      },
      {
        name: 'بهمن',
        value: 40
      },
      {
        name: 'اسفند',
        value: 30
      }
    ]
  }
];
